module.exports = __webpack_public_path__ + "img/L1060600.99c2f1da.jpg";